// Helpers puros dos totalizadores da tela detalhada do BESS (SGD-3682).

export const NO_DATA = "-";

const POWER_DECIMALS = 1;
const SOC_DECIMALS = 1;
const ENERGY_DECIMALS = 3;

type MaybeNumber = number | null | undefined;

const format = (value: MaybeNumber, decimals: number): string =>
    value === null || value === undefined ? NO_DATA : value.toFixed(decimals);

export const formatSoc = (value: MaybeNumber): string => format(value, SOC_DECIMALS);

export const formatEnergy = (value: MaybeNumber): string => format(value, ENERGY_DECIMALS);

export const formatSignedPower = (value: MaybeNumber): string => {
    if (value === null || value === undefined) {
        return NO_DATA;
    }
    const sign = value > 0 ? "+" : "";
    return `${sign}${value.toFixed(POWER_DECIMALS)}`;
};

export const unitOf = (value: MaybeNumber, unity: string | null | undefined): string | undefined =>
    value === null || value === undefined ? undefined : unity ?? undefined;

export const computePowerScalePercent = (
    value: MaybeNumber,
    minPower: MaybeNumber,
    maxPower: MaybeNumber
): number | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (value < 0) {
        if (minPower === null || minPower === undefined || minPower === 0) {
            return undefined;
        }
        return -(Math.abs(value) / Math.abs(minPower)) * 100;
    }
    if (value > 0) {
        if (maxPower === null || maxPower === undefined || maxPower === 0) {
            return undefined;
        }
        return (value / maxPower) * 100;
    }
    return 0;
};
